import { render, staticRenderFns } from "./ordering.vue?vue&type=template&id=5740ce1e&scoped=true&"
import script from "./ordering.vue?vue&type=script&lang=js&"
export * from "./ordering.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5740ce1e",
  null
  
)

export default component.exports